module.exports = __webpack_public_path__ + "76bbbed3e776a65953a32cdff3bd0c76.png";